import { CountryCode } from '~/core/enums';
import { Broadcast } from '~/core/types';

const MAX_NETWORK_CODE = 'MAX';
const NHLN_NETWORK_CODE = 'NHLN';
const TVA_NETWORK_CODE = 'TVAS';

export const isMaxBroadcast = (broadcasts: Array<Broadcast>) =>
    broadcasts.find((broadcast) => broadcast.network === MAX_NETWORK_CODE) !== undefined;

export const isTVABroadcast = (broadcasts: Array<Broadcast>) =>
    broadcasts.find((broadcast) => broadcast.network.includes(TVA_NETWORK_CODE)) !== undefined;

export const isNoStreamBroadcast = (countryCode: CountryCode, broadcasts: Array<Broadcast>) =>
    countryCode === CountryCode.UnitedStates &&
    broadcasts.find((broadcast) => broadcast.network === NHLN_NETWORK_CODE) !== undefined;
